// Device storage estimate for the existing mono 16kHz PCM1 capture protocol.
// Estimates are warnings, never promises about a browser's actual quota.
import {
  CAPTURE_FRAME_SAMPLES,
  CAPTURE_SAMPLE_RATE,
  PCM1_FRAME_HEADER_BYTES,
  PCM1_HEADER_BYTES,
  CAPTURE_FRAMES_PER_CHUNK,
} from './meeting-capture-chunks';

export const STORAGE_MIN_BYTES = 64 * 1024 * 1024;

/** Full PCM1 bytes at the actual capability horizon, including its short tail. */
export function recordingBytes(durationMs: number): number {
  const samples = Math.max(0, Math.ceil((durationMs * CAPTURE_SAMPLE_RATE) / 1000));
  const frames = Math.ceil(samples / CAPTURE_FRAME_SAMPLES);
  return (
    samples * 2 +
    frames * PCM1_FRAME_HEADER_BYTES +
    Math.ceil(frames / CAPTURE_FRAMES_PER_CHUNK) * PCM1_HEADER_BYTES
  );
}

export type RecordingStorageWarning = 'low' | 'unknown' | null;

export function recordingStorageWarning(
  estimate: { quota?: number; usage?: number } | null | undefined,
  remainingMs: number,
  pendingBytes = 0,
): RecordingStorageWarning {
  if (!Number.isFinite(estimate?.quota) || !Number.isFinite(estimate?.usage)) return 'unknown';
  // Reserve metadata/IndexedDB headroom; it is not a measured overhead guarantee.
  const needed = Math.ceil((recordingBytes(remainingMs) + pendingBytes) * 1.25) + STORAGE_MIN_BYTES;
  return estimate!.quota! - estimate!.usage! < needed ? 'low' : null;
}
